import request from '@/utils/request'

/* 逾期汇总表 - 列表 */
export function getOverDueSummaryList(data) {
  return request({
    // url: '/mock/852/admin/v1/vehicle/debt/getOverDueSummary',
    url: '/admin/v1/vehicle/debt/getOverDueSummary',
    method: 'POST',
    data,
  })
}

/* 逾期汇总表 - 金额统计 */
export function amountSummary(data) {
  return request({
    // url: '/mock/852/admin/v1/vehicle/debt/summary/amountSummary',
    url: '/admin/v1/vehicle/debt/summary/amountSummary',
    method: 'POST',
    data,
  })
}
/* 逾期汇总表 - 汇总详细 (企业/个人) */
export function detailOverDue(data) {
  return request({
    url: '/admin/v1/vehicle/debt/detailOverDue',
    method: 'POST',
    data,
  })
}

/* 逾期汇总表 - 汇总详细 - 统计 */
export function receivableSummary(data) {
  return request({
    url: '/admin/v1/vehicle/debt/summary/receivableSummary',
    method: 'POST',
    data,
  })
}

/* 催租 - 逾期明细表 - 列表 */
export function getOverDueItems(data) {
  return request({
    url: '/admin/v1/vehicle/debt/getOverDueItems',
    method: 'POST',
    data,
  })
}

/* 催租 - 预提醒明细表 - 列表 */
export function getRemindItems(data) {
  return request({
    url: '/admin/v1/vehicle/debt/getRemindItems',
    method: 'POST',
    data,
  })
}

/* 催租 - 逾期配置 - 详情 */
export function overdueConfigDetail(data) {
  return request({
    url: '/admin/v1/vehicle/hastenDebt/overdueConfig/getDetail',
    method: 'POST',
    data,
  })
}

/* 催租 - 逾期配置 - 保存 */
export function overdueConfigSave(data) {
  return request({
    url: '/admin/v1/vehicle/hastenDebt/overdueConfig/save',
    method: 'POST',
    data,
  })
}

/* 催租 - 逾期明细异步导出 */
export function asyncOverdueExport(data) {
  return request({
    url: '/admin/v1/vehicle/debt/overdue/export',
    method: 'POST',
    data,
  })
}

/* 催租 - 异步任务列表（导出） */
export function asyncExportList(data) {
  return request({
    url: '/admin/v1/vehicle/async/export/list',
    method: 'POST',
    data,
  })
}

/* 催租 - 添加跟进记录 */
export function addFollow(data) {
  return request({
    url: '/admin/v1/vehicle/debt/follow/add',
    method: 'POST',
    data,
  })
}

/* 催租 - 逾期单详情 */
export function overdueDetail(data) {
  return request({
    url: '/admin/v1/vehicle/debt/overdue/detail',
    method: 'POST',
    data,
  })
}

